module.exports = __webpack_public_path__ + "img/allowed.65a646b1.jpg";